import styled from 'styled-components';
import Wave from '../../assets/img/wave.svg';

export const Header = styled.header`
	padding: 1.5em 0 1em;
	z-index: 9000;
`;

export const HeaderWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const Logo = styled.button`
	font-family: 'Futura';
	-webkit-appearance: none;
	background: none;
	border: none;

	img {
		width: 105px;
	}

	@media screen and (min-width: 640px) {
		img {
			width: 160px;
		}
	}
`;
export const MenuButton = styled.button`
	border: none;
	@media screen and (min-width: 650px) {
		display: none;
	}
`;

export const NavListWrapper = styled.nav`
	padding: 0.5em 0;
    transition: all 500ms ease-in-out;

	@media screen and (max-width: 650px) {
	    position: absolute;
        background: #f3f2ec;
        opacity: 0;
        visibility: hidden;
        transform: translateX(1000px);
        width: 100%;
        top: 80px;
        left: 0;
        right: 0;
        padding: 25px;
        height: 300px;
        z-index: 9999;
        border-bottom: 1px solid #d8d8cf;

        &.show {
            opacity: 1;
            visibility: visible;
            transform: translateX(0);
        }
	}
`;

export const NavList = styled.ul`
	@media screen and (min-width: 650px) {
		display: flex;
		align-items: center;
		justify-content: space-between;

        > * {
            padding: 20px 0;
        }
	}
`;

export const NavListItem = styled.li`
    @media screen and (min-width: 650px) {
        margin-left: 50px;
    }

	& .nav-list--item {
		&-main {
			text-transform: uppercase;
			font-family: 'Futura';
			letter-spacing: -1px;
			font-size: 22px;

			img {
				display: inline-block;
				vertical-align: middle;
				margin-left: 10px;
				margin-top: -3px;
				-moz-transition: 300ms ease-in-out;
				-webkit-transition: 300ms ease-in-out;
				transition: 300ms ease-in-out;
			}

			&:hover {
				img {
					transform: rotate(45deg);
				}
			}
		}

		span {
			position: relative;
			&::before {
				position: absolute;
				bottom: -2px;
				left: 0;
				right: 0;
				height: 1px;
				content: '';
				background-color: #403d3d;
				transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
				transform-origin: right center;
				transform: scaleX(0);
			}

			&:hover {
				&::before {
					transform: scaleX(1);
				}
			}
		}
	}
`;

export const LineWrapper = styled.div`
	margin: 0 auto;
	max-width: 1440px;
	padding: 0 25px;
	position: relative;
`;

export const Line = styled.div`
	position: fixed;
	height: 100vh;
	width: 1px;
	top: 0;
	z-index: 99;
	-moz-transition: 300ms ease-in-out;
	-webkit-transition: 300ms ease-in-out;
	transition: 300ms ease-in-out;

	&.line-left {
		left: 0;
		transform: translateX(10px);
	}
	&.line-right {
		transform: translateX(-10px);
		right: 0;
	}

	@media screen and (min-width: 640px) {
		background: #e2e2d4;
		&.line-left {
			left: 0;
			transform: translateX(40px);
		}
		&.line-middle {
			transform: translate(60px 40px);
		}
		&.line-right {
			transform: translateX(-40px);
			right: 0;
		}
	}
`;

export const LineLeft = styled.div`
	position: fixed;
	background: #e2e2d4;
	height: 100px;
	width: 1px;
	z-index: -1;
	-moz-transition: 300ms ease-in-out;
	-webkit-transition: 300ms ease-in-out;
	transition: 300ms ease-in-out;
`;

export const LineRight = styled.div`
	position: fixed;
	background: #e2e2d4;
	height: 100px;
	width: 1px;
	z-index: -1;
	-moz-transition: 300ms ease-in-out;
	-webkit-transition: 300ms ease-in-out;
	transition: 300ms ease-in-out;
`;

export const Footer = styled.footer`
	pointer-events: auto;
	padding: 3em 0 2em;
	background-color: #ecebe3;

    @media screen and (min-width: 650px) {
        position: sticky;
        bottom: 0;
        left: 0;
        width: 100%;
    }

	// &:before {
	// 	content: '';
	// 	top: 0;
	// 	position: absolute;
	// 	background: url(${Wave}) repeat;
	// 	display: block;
	// 	width: 100%;
	// 	height: 4px;
	// }
`;

export const FooterWrapper = styled.div`
	text-align: left;

	@media screen and (min-width: 650px) {
		display: flex;
		justify-content: space-between;
		flex-direction: row;
	}
`;

export const FooterText = styled.small`
	display: block;

	@media screen and (min-width: 650px) {
		max-width: 30%;
	}
`;

export const FooterSmall = styled.small`
	display: block;
	margin: 20px 0 30px;

	&.smaller {
		font-size: 15px;
	}

	@media screen and (min-width: 650px) {
		margin: 20px 0 0;
	}
`;

export const FooterImage = styled.img`
	display: inline-block;
	width: 40px;
	height: 40px;

	&:nth-child(2n) {
		margin-left: 8px;
	}

	@media screen and (min-width: 650px) {
		width: 55px;
		height: 55px;
	}
`;

export const FooterSocialIcon = styled.li`
	display: inline-block;
	margin: 20px 17px 0 0;
	cursor: pointer;
`;
